import React, { Component } from 'react'

import { connect } from "react-redux"
import { increment, decrement } from "../features/counter/counterSlice"
import { setLoggedIn } from "../features/account/loginSlice"
import { setAccount } from "../features/account/accountSlice"
import { setCompany } from "../features/account/companySlice"

import Stepper from '../components/Stepper';
import onboardform from '../features/onboard/onboard.json';
import { withTranslation } from 'react-i18next';


const forms = onboardform

export class Onboard extends Component {
    render() {
        return (
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">

                            <div className='card'>
                                <div className='card-header'>
                                    <h4 className='card-title mb-0 flex-grow-1'>Onboard</h4> </div>
                                <div className='card-body'>
                                    <Stepper form={forms} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
  count: state.counter.value,
  loggedIn: state.loggedIn.value,
  account: state.account.value,
  company: state.company.value,
});

const mapDispatchToProps = { increment, decrement, setLoggedIn, setAccount, setCompany };

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Onboard));
